import React from 'react';
import { graphql, Link } from 'gatsby';
import { Helmet } from 'react-helmet';

import Layout from '../components/Layout';
import PageFooter from '../components/PageFooter';
import SideBar from '../components/Sidebar';
import Feature from '../components/Feature';

import banner from '../assets/images/banner.jpg';

const sections = [
  { id: 'one', name: 'Inicio' },
  { id: 'two', name: 'Proyectos' },
];
const IndexPage = ({ data }) => (
  <Layout>
    <Helmet>
      <script
        src="https://kit.fontawesome.com/3c46186838.js"
        crossorigin="anonymous"
      ></script>
    </Helmet>
    <SideBar sections={sections} />
    <div id="wrapper">
      <div id="main">
        <section id="one">
          <div className="image main" data-position="center">
            <img src={banner} alt="" />
          </div>
          <div className="container">
            <header className="major">
              <h2>AD Ingeniería</h2>
              <Link to="/" className="button primary">
                Volver al inicio
              </Link>
            </header>
          </div>
        </section>

        <section id="two">
          <div className="container">
            <h3>Últimos proyectos</h3>
            <p></p>
            <div className="features">
              {data.allMarkdownRemark.edges.map(({ node }) => (
                <Feature
                  pic={node.frontmatter.imagen}
                  title={node.frontmatter.title}
                >
                  <div dangerouslySetInnerHTML={{ __html: node.html }}></div>
                </Feature>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
    <section id="footer">
      <PageFooter />
    </section>
  </Layout>
);

export const query = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: frontmatter___fechapublicacion, order: DESC }
    ) {
      edges {
        node {
          html
          frontmatter {
            imagen
            title
          }
        }
      }
    }
  }
`;

export default IndexPage;
